import { Box, Typography } from '@material-ui/core'
import { Accept } from 'react-dropzone'
import { Controller, ControllerProps, FieldValues } from 'react-hook-form'

import DropzoneInput from '@/components/dropzone-input'

type CustomDropzoneComponent = <T extends FieldValues>(
  props: Pick<ControllerProps<T>, 'control' | 'name'> & {
    label: string
    accept: Accept
    labelViewImagesCount?: boolean
    errors?: (string | undefined)[]
    maxFiles?: number
    className?: string
    onDrop?: () => void
  },
) => JSX.Element

export const CustomDropzone: CustomDropzoneComponent = ({
  className,
  control,
  name,
  label,
  accept,
  labelViewImagesCount = false,
  errors = [],
  maxFiles,
  onDrop,
}) => {
  return (
    <Box className={className}>
      <Typography variant={'body1'}>{label}</Typography>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <DropzoneInput
              activeLabel='Solte o arquivo aqui'
              error={
                error?.type === 'custom' ? [error?.message, ...errors] : errors
              }
              label={
                <>
                  <span>Clique para selecionar o arquivo</span> ou solte o
                  arquivo aqui.
                </>
              }
              files={value}
              onDropAccepted={(files) => onChange(files)}
              onClearFiles={() => onChange([])}
              accept={accept}
              labelViewImagesCount={labelViewImagesCount}
              maxFiles={maxFiles}
              onDrop={onDrop}
            />
          </>
        )}
      />
    </Box>
  )
}
